import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getCampaignQueryKey } from "../lib/campaignQuery"
import { getCampaignsQueryKey } from "../lib/campaignsQuery"

export const useArchiveCampaignMutation = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(`/campaigns/${id}/archive`)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(id) })
      queryClient.invalidateQueries({ queryKey: getCampaignsQueryKey() })
    },
  })
}
